import { fetchCurrentUserAction, signInAction } from "./actions";
import { signOutAction } from "./actions";
import { push } from "connected-react-router";
import { auth, db, FirebaseTimestamp, storage } from "../../firebase/index";
import { hideLoadingAction, showLoadingAction } from "../loading/actions";
import firebase from "firebase/app";

const usersRef = db.collection("users");
const storageRef = storage.ref();
const usersImageRef = storageRef.child("users");

export const listenAuthState = () => {
  return async (dispatch) => {
    return auth.onAuthStateChanged((user) => {
      if (user) {
        const uid = user.uid;

        db.collection("users")
          .doc(uid)
          .get()
          .then((snapshot) => {
            const data = snapshot.data();

            dispatch(
              signInAction({
                isSignedIn: true,
                uid: uid,
                username: data.username,
                avatar: data.avatar,
              })
            );
          });
      } else {
        dispatch(push("/signin"));
      }
    });
  };
};

export const fechAuthState = () => {
  return async (dispatch) => {
    return auth.onAuthStateChanged((user) => {
      if (user) {
        const uid = user.uid;

        db.collection("users")
          .doc(uid)
          .get()
          .then((snapshot) => {
            const data = snapshot.data();

            dispatch(
              signInAction({
                isSignedIn: true,
                uid: uid,
                username: data.username,
                avatar: data.avatar,
              })
            );
          });
      } else {
      }
    });
  };
};

export const fechCurrentUser = (state) => {
  return async (dispatch) => {
    const uid = state;
    db.collection("users")
      .doc(uid)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();

        dispatch(fetchCurrentUserAction(data));
      });
  };
};

export const signUp = (username, email, password, cofirmPassword) => {
  return async (dispatch) => {
    if (username === "" || email === "" || password === "" || cofirmPassword === "") {
      alert("必須項目を入力してください");
      return false;
    }
    if (password !== cofirmPassword) {
      alert("パスワードが一致しません");
      return false;
    }
    return auth
      .createUserWithEmailAndPassword(email, password)
      .then((result) => {
        dispatch(showLoadingAction("登録中..."));

        const user = result.user;

        if (user) {
          const uid = user.uid;
          const timestamp = FirebaseTimestamp.now();

          //ユーザー登録時にFBに入れるフィールド
          const userInitialData = {
            created_at: timestamp,
            email: email,
            isCntracted: false,
            uid: uid,
            updated_at: timestamp,
            username: username,
            // avatar:
            //   "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2Fno-profile.png?alt=media&token=fb06ced1-5878-4ce1-8604-1952ecfa7b93",
          };

          db.collection("users")
            .doc(uid)
            .set(userInitialData)
            .then(() => {
              //登録後すぐに変更しておきたい(使いまわしたい)state
              dispatch(
                signInAction({
                  isSignedIn: true,
                  role: "customer",
                  uid: uid,
                  username: username,
                })
              );
              dispatch(hideLoadingAction());
              alert("アカウントを登録しました!");
              dispatch(push("/boothlist"));
            });
        }
      })
      .catch((error) => {
        dispatch(hideLoadingAction());
        // alert("アカウント登録に失敗しました。もう1度お試しください。");
        // throw new Error(error);
        //エラーのメッセージの表示
        switch (error.code) {
          case "auth/network-request-failed":
            alert(
              "通信がエラーになったのか、またはタイムアウトになりました。通信環境がいい所で再度やり直してください。"
            );
            break;
          case "auth/weak-password": //バリデーションでいかないようにするので、基本的にはこのコードはこない
            alert("パスワードが短すぎます。6文字以上を入力してください。");
            break;
          case "auth/invalid-email": //バリデーションでいかないようにするので、基本的にはこのコードはこない
            alert("メールアドレスが正しくありません");
            break;
          case "auth/email-already-in-use":
            alert("メールアドレスがすでに使用されています。ログインするか別のメールアドレスで作成してください");
            break;
          default:
            //想定外
            alert("アカウントの作成に失敗しました。通信環境がいい所で再度やり直してください。");
        }
      });
  };
};

export const signIn = (email, password) => {
  return async (dispatch) => {
    dispatch(showLoadingAction("ログイン中..."));
    if (email === "" || password === "") {
      alert("必須項目を入力してください");
      return false;
    }

    return auth
      .signInWithEmailAndPassword(email, password)
      .then((result) => {
        const user = result.user;
        if (user) {
          const uid = user.uid;

          db.collection("users")
            .doc(uid)
            .get()
            .then((snapshot) => {
              const data = snapshot.data();

              dispatch(
                signInAction({
                  isSignedIn: true,
                  isCntracted: data.isCntracted,
                  uid: uid,
                  username: data.username,
                })
              );
              dispatch(hideLoadingAction());
              alert("ログインに成功しました!");
              dispatch(push("/boothlist"));
            });
        } else {
          dispatch(hideLoadingAction());
          alert("ユーザーを取得できません");
          // throw new Error("ユーザーを取得できません");
        }
      })
      .catch((error) => {
        dispatch(hideLoadingAction());
        // alert("ログインに失敗しました。通信環境を確認してもう1度お試しください");
        // throw new Error(error);
        switch (error.code) {
          case "auth/network-request-failed":
            alert(
              "通信がエラーになったのか、またはタイムアウトになりました。通信環境がいい所で再度やり直してください。"
            );
            break;
          case "auth/user-disabled":
            alert(
              "ユーザーが無効化されています。別のメールアドレスでやり直ししていただくか、再度登録をお願いいたします。"
            );
            break;
          case "auth/invalid-email":
            alert("メールアドレスが正しくありません");
            break;
          case "auth/wrong-password":
            alert("パスワードが正しくありません");
            break;
          case "auth/user-not-found":
            alert("ユーザーが見つかりません。メールアドレスとパスワードをご確認の上、もう1度お試しください");
            break;
          default:
            //想定外
            alert("ログインに失敗しました。通信環境を確認してもう1度お試しください");
        }
      });
  };
};

export const signOut = () => {
  return async (dispatch) => {
    dispatch(showLoadingAction("ログアウト中..."));

    auth
      .signOut()
      .then(() => {
        dispatch(signOutAction());
        dispatch(hideLoadingAction());
        dispatch(push("/signin"));
      })
      .catch(() => {
        dispatch(hideLoadingAction());
        alert("ログアウトに失敗しました。");
      });
  };
};

export const resetPassword = (email) => {
  return async (dispatch) => {
    if (email === "") {
      alert("必須項目を入力してください");
      return false;
    } else {
      auth
        .sendPasswordResetEmail(email)
        .then(() => {
          alert("メールアドレスにリセットメールを送りました");
          dispatch(push("/signin"));
        })
        .catch(() => {
          alert("パスワードリセットに失敗しました。メールアドレスを確認してもう一度お試しください");
        });
    }
  };
};

export const updataEmail = (newMail, email, password, uid) => {
  return async (dispatch) => {
    dispatch(showLoadingAction("更新中..."));
    const data = {
      email: newMail,
    };
    const user = auth.currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    //credentialはインスタンス化したauthでは取得できない
    console.log(credential);
    if (newMail === "" || email === "" || password === "") {
      alert("必須項目を入力してください");
      return false;
    } else {
      user
        .reauthenticateWithCredential(credential)
        .then(() => {
          usersRef
            .doc(uid)
            .set(data, { merge: true })
            .then(() => {
              auth.currentUser
                .updateEmail(newMail)
                .then(() => {
                  dispatch(hideLoadingAction());
                  alert("メールアドレスを変更しました");
                  dispatch(push(`/organizer/${uid}`));
                })
                .catch(() => {
                  dispatch(hideLoadingAction());
                  alert("メールアドレスの変更に失敗しました");
                });
            })
            .catch(() => {
              dispatch(hideLoadingAction());
              alert("メールアドレスの変更に失敗しました");
            });
        })
        .catch(() => {
          dispatch(hideLoadingAction());
          alert("認証できませんでした。入力内容を確認するか、再度ログインをしてからお試しください");
        });
    }
  };
};
export const updataPassword = (newPassword, email, password, uid) => {
  return async (dispatch) => {
    dispatch(showLoadingAction("更新中..."));

    const user = auth.currentUser;
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    if (newPassword === "" || email === "" || password === "") {
      alert("必須項目を入力してください");
      dispatch(hideLoadingAction());
      return false;
    } else {
      user
        .reauthenticateWithCredential(credential)
        .then(() => {
          auth.currentUser
            .updatePassword(newPassword)
            .then(() => {
              dispatch(hideLoadingAction());
              alert("パスワードを変更しました");
              dispatch(push(`/organizer/${uid}`));
            })
            .catch((error) => {
              dispatch(hideLoadingAction());
              // alert("パスワードの変更に失敗しました");
              switch (error.code) {
                case "auth/network-request-failed":
                  dispatch(hideLoadingAction());

                  alert(
                    "通信がエラーになったのか、またはタイムアウトになりました。通信環境がいい所で再度やり直してください。"
                  );
                  break;
                case "auth/weak-password": //バリデーションでいかないようにするので、基本的にはこのコードはこない
                  dispatch(hideLoadingAction());

                  alert("パスワードが短すぎます。6文字以上を入力してください。");
                  break;
                default:
                  //想定外
                  dispatch(hideLoadingAction());
                  alert("パスワードの変更に失敗しました");
              }
            });
        })
        .catch(() => {
          dispatch(hideLoadingAction());
          alert("認証できませんでした。入力内容を確認するか、再度ログインをしてからお試しください");
        });
    }
  };
};
export const deleteUser = (uid, email, password) => {
  return async (dispatch) => {
    dispatch(showLoadingAction("アカウント削除中..."));
    const user = auth.currentUser;
    const deleteAvatarRef = usersImageRef.child(uid).child(uid);
    const credential = firebase.auth.EmailAuthProvider.credential(email, password);
    user
      .reauthenticateWithCredential(credential)
      .then(() => {
        auth.currentUser
          .delete()
          .then(() => {
            usersRef
              .doc(uid)
              .delete()
              .then(() => {
                deleteAvatarRef
                  .delete()
                  .then(() => {
                    dispatch(hideLoadingAction());
                    alert("アカウントが正常に削除されました");
                    dispatch(push("/"));
                  })
                  .catch(() => {
                    dispatch(hideLoadingAction());
                    alert("アカウントは削除されました(画像)");
                  });
              })
              .catch(() => {
                dispatch(hideLoadingAction());
                alert("アカウントは削除されました(DB+画像)");
              });
          })
          .catch(() => {
            dispatch(hideLoadingAction());
            alert("アカウント削除に失敗しました");
          });
      })
      .catch(() => {
        dispatch(hideLoadingAction());
        alert("認証できませんでした。入力内容を確認するか、再度ログインをしてからお試しください");
      });
  };
};

export const saveAvatar = (userId, avatar) => {
  return async (dispatch) => {
    const data = {
      avatar: avatar,
    };
    return usersRef
      .doc(userId)
      .set(data, { merge: true })
      .then(() => {
        dispatch(push(`/organizer/${userId}`));
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

export const saveUser = (userId, name, genre, intro) => {
  return async (dispatch) => {
    if (name === "" || genre === "" || intro === "") {
      alert("未記入では保存できません");
      return false;
    }
    const data = {
      username: name,
      genre: genre,
      intro: intro,
    };
    return usersRef
      .doc(userId)
      .set(data, { merge: true })
      .then(() => {
        dispatch(push(`/organizer/${userId}`));
      })
      .catch((error) => {
        throw new Error(error);
      });
  };
};

// export const buyerSave = (userId, buyerId) => {
//   return async (dispatch) => {
//     const saveRef = usersRef.doc(userId).collection("buyers").doc();
//     const data = {
//       buyerId: buyerId,
//     };
//     return saveRef
//       .set(data, { merge: true })
//       .then()
//       .catch((error) => {
//         throw new Error(error);
//       });
//   };
// };
